import { call, put, takeEvery } from 'redux-saga/effects';
import * as type from '../ActionTypes';
import {
  saveSelectedSkillService,
  saveSkillExperienceService,
  updateSelectedSkillService,
  updateSkillExperienceService
} from '../../services/skill';

function* saveSelectedSkill(action: any): any {
  try {
    const res = yield call(saveSelectedSkillService, action.payload);
    if (res?.statusCode !== 201) {
      yield put({ type: type.SAVE_SKILL_FAILURE, error: 'Something went wrong' });
    }
  } catch (e: any) {
    yield put({ type: type.SAVE_SKILL_FAILURE, error: e.error });
  }
}

function* saveSkillExperience(action: any): any {
  try {
    const response = yield call(saveSkillExperienceService, action.payload);
    if (response?.statusCode === 201) {
      yield put({ type: type.SAVE_SKILL_EXPERIENCE_SUCESS, data: response.data });
    } else {
      yield put({ type: type.SAVE_SKILL_EXPERIENCE_FAILURE, error: 'Something went wrong' });
    }
  } catch (e: any) {
    yield put({ type: type.SAVE_SKILL_EXPERIENCE_FAILURE, error: e.error });
    // yield put({ type: type.JOB_CREATION_ERROR, message: e.message });
  }
}
function* updateSelectedSkill(action: any): any {
  try {
    const res = yield call(updateSelectedSkillService, action.payload, action.userId);
    if (res?.statusCode !== 200) {
      yield put({ type: type.SAVE_SKILL_FAILURE, error: 'Something went wrong' });
    }
  } catch (e: any) {
    yield put({ type: type.SAVE_SKILL_FAILURE, error: e.error });
  }
}

function* updateSkillExperience(action: any): any {
  try {
    const response = yield call(updateSkillExperienceService, action.payload, action.userId);
    if (response?.statusCode === 200) {
      yield put({ type: type.SAVE_SKILL_EXPERIENCE_SUCESS, data: response.data });
    } else {
      yield put({ type: type.SAVE_SKILL_EXPERIENCE_FAILURE, error: 'Something went wrong' });
    }
  } catch (e: any) {
    yield put({ type: type.SAVE_SKILL_EXPERIENCE_FAILURE, error: e.error });
    // yield put({ type: type.JOB_CREATION_ERROR, message: e.message });
  }
}
function* skillAndExperienceSaga() {
  yield takeEvery(type.SAVE_SKILL_REQUEST, saveSelectedSkill);
  yield takeEvery(type.SAVE_SKILL_EXPERIENCE_REQUEST, saveSkillExperience);
  yield takeEvery(type.UPDATE_SKILL_REQUEST, updateSelectedSkill);
  yield takeEvery(type.UPDATE_SKILL_EXPERIENCE_REQUEST, updateSkillExperience);
}

export default skillAndExperienceSaga;
